import { Plus, Search, RefreshCw } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { CardHeader, CardTitle } from "../../../components/ui/card";

export const CategoriesHeader = ({
  isDialogOpen,
  setIsDialogOpen,
  searchTerm,
  setSearchTerm,
  setEditingCategory,
  formData,
  setFormData,
  editingCategory,
  filteredCategories,
  onRefresh,
}) => {
  return (
    <div>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle>Categories ({filteredCategories.length})</CardTitle>
          {onRefresh && (
            <Button
              variant="outline"
              size="sm"
              onClick={onRefresh}
              className="ml-2"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Refresh
            </Button>
          )}
        </div>
      </CardHeader>
      <div className="flex justify-between items-center px-6 pb-4">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
          <Input
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
          />
        </div>

        <Button
          onClick={() => {
            setEditingCategory(null);
            // Fixed: Changed 'active' to 'status' and removed 'description'
            setFormData({ name: "", status: true });
            setIsDialogOpen(true);
          }}
          className="ml-4"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Category
        </Button>
      </div>
    </div>
  );
};